<div class="wrapper">
  <div (click)="emitStep.emit(0)" class="step" [class.active]="stepIndex === 0" [class.passed]="stepIndex > 0">
    <cf-text weight="500" size="sm" color="white"> 1. {{ "date" | translate }} </cf-text>
    <div class="progress"></div>
  </div>

  <div (click)="emitStep.emit(1)" class="step" [class.active]="stepIndex === 1" [class.passed]="stepIndex > 1">
    <cf-text weight="500" size="sm" color="white"> 2. {{ "time" | translate }} </cf-text>
    <div class="progress"></div>
  </div>

  <div class="step" [class.active]="stepIndex === 2" [class.passed]="stepIndex > 2">
    <cf-text weight="500" size="sm" color="white"> 3. {{ "name" | translate }} </cf-text>
    <div class="progress"></div>
  </div>
</div>
